<template>
  <v-avatar
    color="primary"
    out
    :size="avatarSize"
    :style="{'min-width' : avatarSize, 'max-width': avatarSize}"
  >
    <v-img
      v-if="hasImage"
      :src="imageUrl"
      @error="onLoadError"
    />
    <span
      v-if="!hasImage"
      class="accent--text"
      :style="{'font-size': fontSize}"
    >{{ initials }}</span>
  </v-avatar>
</template>
<script>
import { get } from 'lodash'

export default {
  props: {
    imageUrl: {
      type: String,
      default: ''
    },
    firstname: {
      type: String,
      default: ''
    },
    lastname: {
      type: String,
      default: ''
    },
    displayName: {
      type: String,
      default: ''
    },
    size: {
      type: Number,
      default: 0
    },
    font: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      imageLoads: true
    }
  },
  computed: {
    hasImage() {
      return this.imageUrl && this.imageLoads
    },
    initials() {
      let initials = ''
      const displayName = this.displayName || ''
      const splitName = displayName.split(' ')
      const namePart1 = get(splitName, '[0]', '')
      const namePart2 = get(splitName, '[1]', '')
      const firstname = this.firstname || namePart1
      const lastname = this.lastname || namePart2

      if (firstname) {
        initials += firstname.charAt(0).toUpperCase()
      }
      if (lastname) {
        initials += lastname.charAt(0).toUpperCase()
      }
      return initials
    },
    avatarSize() {
      return `${this.size}px`
    },
    fontSize() {
      return `${this.font}px`
    }
  },
  watch: {
    imageUrl() {
      // If a new image URL is supplied, reset the imageLoads value
      // The error handler will be called if it fails again
      this.imageLoads = true
    }
  },
  methods: {
    onLoadError() {
      this.imageLoads = false
    }
  }
}
</script>
